import {
    namespace,
    reducer,
    selectors,
} from './base';
import * as operations from './operations';

const fetchTripsAction = {
    ...operations,
    ...selectors,
};

export {
    fetchTripsAction,
};
export default {
    [namespace]: reducer,
};
